import { nodes as basicNodes, marks as basicMarks } from 'ngx-editor';
import { toStyleString } from 'ngx-editor/utils';
import { NodeSpec, Schema } from 'prosemirror-model';
import { fontMark } from './font.mark';

function buildSchema() {
  const div: NodeSpec = {
    content: 'inline*',
    group: 'block',
    attrs: {},
    parseDOM: [{ tag: 'div' }],
    toDOM() { return ['div', 0] },
  };

  const nodes = { div, ...basicNodes };

  const marks = { ...basicMarks, fontMark, };

  return new Schema({
    nodes,
    marks
  });
};

const templateDefinitionEditorSchema = buildSchema();

export default templateDefinitionEditorSchema;
